(function () {
  var root = document.querySelector(".lsm[data-card-variant]");
  if (!root) return;

  var CARD_VARIANT = +root.dataset.cardVariant, CARD_PRICE = +root.dataset.cardPrice; // kuruş
  var KIT_VARIANT = +root.dataset.kitVariant || 0, KIT_PRICE = +root.dataset.kitPrice || 0;
  var LOGO = root.dataset.logo;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return {"&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;"}[c]; }); };
  var up = function (s) { return s.toLocaleUpperCase("tr-TR"); };
  var tl = function (cents) { return (cents / 100).toLocaleString("tr-TR", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " TL"; };

  var HEART = '<path d="M50 88 12 50C-2 34 10 8 32 10c9 1 15 6 18 12 3-6 9-11 18-12 22-2 34 24 20 40z"/>';
  var T = function (lines) {
    return lines.map(function (l) {
      return '<text x="50" y="' + l.y + '" text-anchor="middle" font-family="Big Shoulders Stencil Display,Impact,sans-serif" font-weight="800" font-size="' + l.s + '" fill="#f6efe4">' + esc(l.t) + "</text>";
    }).join("");
  };
  var heart = function (x, y, k) { return '<g fill="#f6efe4" transform="translate(' + x + " " + y + ") scale(" + k + ')">' + HEART + "</g>"; };
  var fit = function (t, max) { return Math.min(max, 90 / Math.max(2, t.length) * 1.5); };
  var words = function (v) {
    var w = up(v[0]).split(" ").slice(0, 3);
    return T(w.map(function (x, i) { return {t: x, y: 50 + (i - (w.length - 1) / 2) * 26 + 9, s: fit(x, 28)}; }));
  };

  var DESIGNS = [
    {id: "iki-isim", name: "İki isim, kalp", cat: "Romantik", f: [["1. isim", "AYŞE", 9], ["2. isim", "MURAT", 9]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]), y: 30, s: fit(v[0], 26)}, {t: up(v[1]), y: 88, s: fit(v[1], 26)}]) + heart(36, 40, .28) + "</svg>"; }},
    {id: "isim-isim", name: "İsim & isim", cat: "Romantik", f: [["1. isim", "AYŞE", 9], ["2. isim", "MURAT", 9]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]), y: 36, s: fit(v[0], 24)}, {t: "&", y: 60, s: 18}, {t: up(v[1]), y: 84, s: fit(v[1], 24)}]) + "</svg>"; }},
    {id: "bas-harf", name: "Baş harfler", cat: "Romantik", f: [["1. harf", "A", 1], ["2. harf", "M", 1]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]) + " & " + up(v[1]), y: 64, s: 34}]) + "</svg>"; }},
    {id: "askim", name: "Aşkım", cat: "Romantik", f: [["Yazı", "AŞKIM", 10]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + heart(36, 16, .28) + T([{t: up(v[0]), y: 78, s: fit(v[0], 24)}]) + "</svg>"; }},
    {id: "once-kahve", name: "Önce kahve", cat: "Sözler", f: [["Yazı", "ÖNCE KAHVE", 14]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + words(v) + "</svg>"; }},
    {id: "gunaydin", name: "Günaydın", cat: "Sözler", f: [["Yazı", "GÜNAYDIN", 12]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]), y: 58, s: fit(v[0], 22)}]) + "</svg>"; }},
    {id: "sarj", name: "Şarjım doldu", cat: "Sözler", f: [["Yazı", "ŞARJIM DOLDU", 14]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + words(v) + "</svg>"; }},
    {id: "annem", name: "Annem", cat: "Aile", f: [["Yazı", "ANNEM", 10]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + heart(36, 22, .28) + T([{t: up(v[0]), y: 78, s: fit(v[0], 26)}]) + "</svg>"; }},
    {id: "baba", name: "Babam", cat: "Aile", f: [["Yazı", "BABAM", 10]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]), y: 60, s: fit(v[0], 28)}]) + "</svg>"; }},
    {id: "yuva", name: "Yuvamız", cat: "Aile", f: [["Yazı", "YUVAMIZ", 12]],
      svg: function (v) { return '<svg viewBox="0 0 100 100"><path d="M50 14 18 44h9v22h46V44h9z" fill="#f6efe4"/>' + T([{t: up(v[0]), y: 90, s: fit(v[0], 20)}]) + "</svg>"; }},
    {id: "kutlama", name: "Tebrikler", cat: "Kutlama", f: [["Yazı", "TEBRİKLER", 12]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: "★ ★ ★", y: 34, s: 14}, {t: up(v[0]), y: 70, s: fit(v[0], 22)}]) + "</svg>"; }},
    {id: "dogumgunu", name: "İyi ki doğdun", cat: "Kutlama", f: [["İsim", "AYŞE", 10]],
      svg: function (v) { return '<svg viewBox="0 0 100 100">' + T([{t: up(v[0]), y: 48, s: fit(v[0], 26)}, {t: "İYİ Kİ DOĞDUN", y: 78, s: 13}]) + "</svg>"; }},
    {id: "pati", name: "Pati", cat: "Hayvanlar", f: [["İsim", "KARABAŞ", 10]],
      svg: function (v) { return '<svg viewBox="0 0 100 100" fill="#f6efe4"><ellipse cx="50" cy="42" rx="13" ry="10"/><circle cx="31" cy="30" r="6"/><circle cx="43" cy="20" r="6"/><circle cx="57" cy="20" r="6"/><circle cx="69" cy="30" r="6"/>' + T([{t: up(v[0]), y: 84, s: fit(v[0], 22)}]) + "</svg>"; }},
    {id: "logo", name: "Latte Shot logosu", cat: "Kültür", f: [],
      svg: function () { return '<svg viewBox="0 0 100 100"><image href="' + LOGO + '" x="8" y="8" width="84" height="84" style="filter:invert(1) sepia(.15)"/></svg>'; }}
  ];
  var CATS = ["Tümü"].concat(DESIGNS.map(function (d) { return d.cat; }).filter(function (c, i, a) { return a.indexOf(c) === i; }));

  var cat = "Tümü", sel = DESIGNS[0], vals = {}, view = "card", cart = [];
  try { cart = JSON.parse(localStorage.getItem("ls.cart") || "[]"); } catch (e) {}
  var save = function () { try { localStorage.setItem("ls.cart", JSON.stringify(cart)); } catch (e) {} };
  var byId = function (id) { return DESIGNS.filter(function (d) { return d.id === id; })[0]; };
  cart = cart.filter(function (c) { return byId(c.id); });

  function values(d) { return d.f.map(function (f, i) { var x = (vals[d.id] || [])[i]; return x == null ? f[1] : x; }); }
  function kitOn() { var r = $('input[name^="lsm-kit"]:checked'); return !!(r && r.value === "1" && KIT_VARIANT); }

  function previewHTML() { return (view === "cup" ? '<div class="lsm-disc"></div>' : "") + sel.svg(values(sel)); }
  function updatePreview() {
    var v = values(sel);
    $("[data-art]").className = "lsm-art" + (view === "cup" ? " is-cup" : "");
    $("[data-art]").innerHTML = previewHTML();
    $("[data-cap]").innerHTML = esc(v.map(up).join(" "));
    $$("[data-fields] .lsm-field label span").forEach(function (s, i) { s.textContent = v[i].length + "/" + sel.f[i][2]; });
    var t = $('[data-grid] [data-id="' + sel.id + '"] .lsm-art'); if (t) t.innerHTML = sel.svg(v);
  }
  function renderCart() {
    var total = cart.length * CARD_PRICE + (kitOn() && cart.length ? KIT_PRICE : 0);
    $("[data-cart]").innerHTML = cart.length ? cart.map(function (c, i) {
      return '<div class="lsm-line"><div class="lsm-art">' + byId(c.id).svg(c.v) + "</div><span>" + esc(c.name) + ": " + esc(c.v.join(" / ")) + "</span><b>" + tl(CARD_PRICE) + '</b><button type="button" data-rm="' + i + '" aria-label="Kaldır">×</button></div>';
    }).join("") : '<p class="lsm-sub">Henüz kart eklemedin. Yukarıdan bir tasarım seç, ismini yaz, "Ekle"ye bas.</p>';
    $$("[data-rm]").forEach(function (b) { b.onclick = function () { cart.splice(+b.dataset.rm, 1); save(); renderCart(); }; });
    $("[data-total]").textContent = tl(total);
    $("[data-buy]").disabled = !cart.length || !$$("[data-ok]").every(function (c) { return c.checked; });
  }
  function render() {
    var v = values(sel);
    $("[data-ed-name]").textContent = sel.name;
    var fields = $("[data-fields]");
    fields.className = "lsm-fields" + (sel.f.length <= 1 ? " one" : "");
    fields.innerHTML = sel.f.length ? sel.f.map(function (f, i) {
      return '<div class="lsm-field"><label>' + f[0] + "<span>" + v[i].length + "/" + f[2] + '</span></label><input data-i="' + i + '" maxlength="' + f[2] + '" value="' + esc(v[i]) + '"></div>';
    }).join("") : '<p class="lsm-sub" style="margin:0">Bu tasarımda yazı yok.</p>';
    $$("[data-fields] input").forEach(function (el) {
      el.oninput = function () { (vals[sel.id] = vals[sel.id] || values(sel))[+el.dataset.i] = el.value; updatePreview(); };
    });
    $("[data-chips]").innerHTML = CATS.map(function (c) { return '<button type="button" class="lsm-chip" aria-pressed="' + (c === cat) + '">' + c + "</button>"; }).join("");
    $$(".lsm-chip").forEach(function (b, i) { b.onclick = function () { cat = CATS[i]; render(); }; });
    $("[data-grid]").innerHTML = DESIGNS.filter(function (d) { return cat === "Tümü" || d.cat === cat; }).map(function (d) {
      return '<button type="button" class="lsm-tile" data-id="' + d.id + '" aria-pressed="' + (d === sel) + '"><div class="lsm-art">' + d.svg(values(d)) + "</div><b>" + d.name + "</b></button>";
    }).join("");
    $$(".lsm-tile").forEach(function (b) { b.onclick = function () { sel = byId(b.dataset.id); render(); }; });
    updatePreview(); renderCart();
  }

  $("[data-add]").onclick = function () { cart.push({id: sel.id, name: sel.name, v: values(sel)}); save(); renderCart(); };
  $$(".lsm-seg button").forEach(function (b) {
    b.onclick = function () { view = b.dataset.view; $$(".lsm-seg button").forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); updatePreview(); };
  });
  $$("[data-ok], input[name^='lsm-kit']").forEach(function (c) { c.onchange = renderCart; });

  $("[data-buy]").onclick = function () {
    var btn = this, err = $("[data-err]");
    err.hidden = true; btn.disabled = true;
    var items = cart.map(function (c) {
      var d = byId(c.id), p = {"Tasarım": c.name};
      d.f.forEach(function (f, i) { p[f[0]] = c.v[i]; });
      p["_design"] = c.id;
      return {id: CARD_VARIANT, quantity: 1, properties: p};
    });
    if (kitOn()) items.push({id: KIT_VARIANT, quantity: 1});
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST", headers: {"Content-Type": "application/json", Accept: "application/json"}, body: JSON.stringify({items: items})
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Sepete eklenemedi"); return j; }); })
      .then(function () { cart = []; save(); window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart"; })
      .catch(function (e) { err.textContent = e.message; err.hidden = false; renderCart(); });
  };
  render();
})();
